import React from "react";

/**
 * Seta que desliza um container rolável na horizontal.
 *
 * É a camada DESCOBRÍVEL da navegação, e existe porque arrastar não se anuncia: o
 * defeito relatado na trilha não era o scroll ser ruim de usar, era não dar para
 * saber que havia mais coisa adiante. A seta responde as duas de uma vez — que
 * existe algo depois, e como chegar lá.
 *
 * Saiu de dentro de `Tabuleiro.jsx` em 05/08/2026, quando o álbum do encerramento
 * virou uma vitrine que rola na horizontal e passou a precisar da mesma seta. Mesmo
 * argumento que já tirou `textoDigitado.js` de `IntroMascote` e `FalaDoMascote` de
 * `CerimoniaCard`: o que serve duas telas não pertence a uma delas.
 *
 * A única diferença em relação à versão que vivia lá são os RÓTULOS, que agora
 * chegam por prop — "Ver as próximas fases" não serve para um álbum de cartas, e
 * rótulo de leitor de tela que mente é pior que rótulo nenhum.
 *
 * Fica montada e escondida por CSS, em vez de sair do DOM: sumir sob os pés de quem
 * chegou nela pelo Tab tiraria o foco da página para o nada. Escondida, ela também
 * sai da ordem de foco (`inert` não tem suporte suficiente; `disabled` resolve o
 * foco e o clique de uma vez).
 *
 * O chevron é desenhado inline, como o ícone de tela cheia e pela mesma razão: dois
 * traços não valem um `.svg` a mais para o jest do CRA substituir por vazio.
 *
 * @param {number}   direcao  -1 para trás, 1 para frente
 * @param {boolean}  visivel  há para onde ir naquele sentido
 * @param {Function} onClick
 * @param {string}   rotulo   o que o leitor de tela anuncia
 * @param {string}   [testid] gancho de teste; o Tabuleiro depende do nome antigo
 */
function SetaDeslizante({ direcao, visivel, onClick, rotulo, testid }) {
  const paraFrente = direcao > 0;
  return (
    <button
      type="button"
      className={`trilha-ludica__seta trilha-ludica__seta--${
        paraFrente ? "avancar" : "voltar"
      }${visivel ? "" : " trilha-ludica__seta--oculta"}`}
      onClick={onClick}
      disabled={!visivel}
      aria-hidden={!visivel}
      data-testid={testid || `trilha-seta-${paraFrente ? "avancar" : "voltar"}`}
    >
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d={paraFrente ? "M9 5l7 7-7 7" : "M15 5l-7 7 7 7"} />
      </svg>
      <span className="trilha-ludica__so-leitor">{rotulo}</span>
    </button>
  );
}

export default SetaDeslizante;
